/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { TenantDataService } from './data.service';
import {
  CreateUserRequest,
  DeleteUserRequest,
  TenantDetails,
  TenantDetailsUpdateRequest,
  TenantDetailsWithFlags,
  User
} from 'app/page-modules/tenant-management/models';
import { observableOf } from 'app/shared/rxjs/rxjs.utils';
import { Observable } from 'rxjs';
import { MockSharedDataService } from 'app/shared-data/services/mock-shared-data.service';
import { delay } from 'rxjs/operators';

/** A mock data service for fetching tenant details */
export class MockTenantDataService implements TenantDataService {
  users: User[] = [
    {
      email: 'js@test.com',
      firstName: 'John',
      lastName: 'Smith',
      picture:
        'http://www.newsshare.in/wp-content/uploads/2017/04/Miniclip-8-Ball-Pool-Avatar-15.png'
    },
    {
      email: 'sj@test.com',
      firstName: 'Boris',
      lastName: 'John',
      picture:
        'http://www.newsshare.in/wp-content/uploads/2017/04/Miniclip-8-Ball-Pool-Avatar-15.png'
    },
    {
      email: 'sj2@opengamma.com',
      firstName: 'David',
      lastName: 'Jmith',
      picture:
        'http://www.newsshare.in/wp-content/uploads/2017/04/Miniclip-8-Ball-Pool-Avatar-15.png'
    },
    {
      email: 'ss2@test.com',
      firstName: 'Sohn',
      lastName: 'Sohn',
      picture:
        'http://www.newsshare.in/wp-content/uploads/2017/04/Miniclip-8-Ball-Pool-Avatar-15.png'
    }
  ];

  constructor(private mockSharedDataService: MockSharedDataService) {}

  deleteTenant(): Observable<void> {
    return observableOf();
  }

  createTenant(tenant: TenantDetails): Observable<TenantDetails> {
    return observableOf(tenant);
  }

  tenantDetails(organizationId: string): Observable<TenantDetailsWithFlags> {
    const allTenantDetails = this.mockSharedDataService.allTenantDetails;
    const match = allTenantDetails.find(tenant => tenant.data.organizationId === organizationId);
    return observableOf(match!).pipe(delay(3000));
  }

  updateTenantDetails(
    organizationId: string,
    successMessage: string,
    updateRequest: TenantDetailsUpdateRequest
  ): Observable<TenantDetailsUpdateRequest> {
    return observableOf(updateRequest);
  }

  addReadOnlyRole(organizationId: string): Observable<void> {
    return observableOf(undefined).pipe(delay(1000));
  }

  usersForTenant(tenantName: string): Observable<User[]> {
    return observableOf(this.users.map(user => ({ ...user, organizationId: tenantName })));
  }

  addUserForTenant(organizationId: string, request: CreateUserRequest): Observable<User> {
    const user: User = {
      email: request.email,
      firstName: request.firstName,
      lastName: request.lastName,
      picture: '',
      organizationId: organizationId
    };
    return observableOf(user);
  }

  updateUserForTenant(organizationId: string, user: User): Observable<User> {
    return observableOf(user);
  }

  deleteUser(user: User, deleteUserRequest: DeleteUserRequest): Observable<User> {
    return observableOf(user);
  }
}
